import { createContext } from 'react';

import { WizardValues } from './types';

const WizardContext = createContext<WizardValues | null>(null);

export default WizardContext;
